export default {
      id: "kamaz-usage",
      viewBox: "0 0 60 84",
      url: __webpack_public_path__ + "sprite.svg#kamaz-usage",
      toString: function () {
        return this.url;
      }
    }